export const WIDGET_ERROR_MESSAGES = {
  token: 'データ表示可能時間を超過しました。画面を表示し直してください。',
  ticker: '銘柄コードをご確認ください。',
  mkt: '市場をご確認ください。',
  tab: '指定されたページが見つかりません。',
} as const;

export type WidgetErrorKey = keyof typeof WIDGET_ERROR_MESSAGES;
